import { useNavigate } from "react-router-dom"
import MTable from "../../../components/mtable"
import { getStorage, STORAGE } from "../../../utils/storage"

export default function Companies() {

    const navigate = useNavigate()
    
    const companiesMapper = {columns: [
        {
            label: "Name",
            value: (item) => item.name,
            width: '1.5fr'
        },
        {
            label: "Members",
            value: (item) => item.totalMembers,
            width: '90px'
        },
        {
            label: "Invites",
            value: (item) => item.totalInvites,
            width: '80px'
        },
        {
            label: "Programs",
            value: (item) => item.totalPrograms,
            width: '90px'
        },
    ]}

    const create = () => navigate('create')
    const details = (company) => navigate(company.id)

    return(<div className="page-xl-centered standard-padding showing">
        <div className="flex space-between gap-xs v-spacer-m">
            <p className="section-title">Companies</p>
            <button className="solid" onClick={create}>Create Company</button>
        </div>
        <MTable path={'companies'} itemsPerPage={15} mapper={companiesMapper} onClick={details}/>
    </div>)
}